export default "__VITE_ASSET__BZXhAhfg__"